import { apiMipe } from '@/core/api/';

export const getLastPeibyStudentsie = async (studentSieId, academicYearId) => {
  return await apiMipe.get('/api/pei/getlastpeibystudentsie', {
    params: {
      studentSieId,
      academicYearId,
    },
  });
};
